module.exports = __webpack_public_path__ + "static/media/imagen_experencia.ef88d7e1.png";